import * as React from 'react';
const SvgLightning = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 15 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.054 9.338l5.166 1.365-8.063 9.096 1.989-7.53-5.497-1.452L10.072 1.7 8.054 9.338z"
        stroke="url(#lightning_svg__paint0_linear_27068_17304)"
        strokeWidth={1.65}
      />
      <defs>
        <linearGradient
          id="lightning_svg__paint0_linear_27068_17304"
          x1={2.08}
          y1={31.017}
          x2={23.209}
          y2={24.588}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.106} stopColor="#FF7100" />
          <stop offset={1} stopColor="#F6DA35" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const MemoSvgLightningYellow = React.memo(SvgLightning);
export default MemoSvgLightningYellow;
